export class ChangeArrivalStateCommand {
  constructor(booking, arrivalState) {
    this.booking = booking;
    this.arrivalState = arrivalState;
  }
}
